<template>
  <div class="h5-learning-center" v-if="isH5">
    <ul
      class="tabs-wrap"
      v-show="['myCourse', 'liveCalendar'].includes($route.name)"
    >
      <li
        v-show="item.mobileShow"
        v-for="item in navList"
        :key="item.key"
        @click="handleClickTab(item)"
        :class="{ active: item.component.includes($route.name) }"
      >
        <div v-if="isElectron">
          <img
            v-if="item.component.includes($route.name)"
            class="active-icon"
            :src="item.activeImg"
            alt=""
          />
          <img v-else class="icon" :src="item.image" alt="" />
        </div>

        {{ item.name }}
      </li>
    </ul>
    <div class="conten-wrap">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import tabList from "../mixins/tab-list.js";
export default {
  mixins: [tabList],
};
</script>

<style lang="scss" scoped>
// h5
.h5-learning-center {
  min-height: 100vh;
  .tabs-wrap {
    background: #f5f5f6;
    z-index: 9;
    position: fixed;
    width: 100%;
    height: 0.96rem;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-weight: 400;
    font-size: 0.4rem;
    color: #515350;
    line-height: 0.56rem;
    li {
      padding-bottom: 0.19rem;
      &:first-child {
        margin-right: 2rem;
      }
    }
    .active {
      position: relative;
      font-weight: 500;
      font-size: 0.4rem;
      color: #0d1400;
      line-height: 0.56rem;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: 0.03rem;
        transform: translateX(-50%);
        background: linear-gradient(
          132deg,
          $linear-gradient-begin 0%,
          $linear-gradient-end 100%
        );
        width: 0.27rem;
        height: 0.05rem;
        border-radius: 0.07rem;
      }
    }
  }
  .conten-wrap {
  }
}
</style>
